import { AnimatePresence, motion } from 'motion/react';
import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { elevationClassName } from '@creditornot/cb-ingredients';
import { color, dimension } from '@creditornot/cb-ingredients/design-tokens';
import { NAVIGATION_MENU_WIDTH } from 'common/constants';
import { media } from 'common/media';

const Root = styled.div`
  align-items: center;
  bottom: calc(16px + var(--offset));
  display: flex;
  justify-content: center;
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
  z-index: 2;

  @media ${media.md} {
    bottom: calc(24px + var(--offset));
  }

  @media ${media.xl} {
    bottom: calc(24px + var(--offset));
    margin-inline-start: ${NAVIGATION_MENU_WIDTH / 2}px;
  }
`;

const MenuContent = styled(motion.div)`
  background-color: ${color.bg};
  border-radius: ${dimension.cornerRadiusMedium};
  color: ${color.text};
  gap: 16px;
  padding: 12px 16px;
`;

type Props = {
  children: ReactNode;
  className?: string;
  offset?: number;
  testId?: string;
  visible: boolean;
};

export function FloatingIsland({ children, className, offset = 0, testId, visible }: Props) {
  return (
    <AnimatePresence>
      {visible && (
        <Root className={className} style={{ '--offset': `${offset}px` } as CSSProperties}>
          <MenuContent
            initial={{ opacity: 0.5, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ scale: 0, opacity: 0, transition: { duration: 0.15 } }}
            className={elevationClassName.medium}
            data-test-id={testId}
          >
            {children}
          </MenuContent>
        </Root>
      )}
    </AnimatePresence>
  );
}
